import { useState, useEffect } from "react";

export function useAdminAuth() {
  const [isAdmin, setIsAdmin] = useState(false);
  // FIX 1: Add setLoading so we can update the state
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check session on mount
    const user = sessionStorage.getItem("admin_user");
    
    if (user) {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
    
    // FIX 2: Set loading to false so the UI knows it can stop showing the spinner/message
    setLoading(false);
  }, []);

  const login = (username) => {
    sessionStorage.setItem("admin_user", username);
    setIsAdmin(true);
  };

  const logout = () => {
    sessionStorage.removeItem("admin_user");
    setIsAdmin(false);
    window.location.href = "/login";
  };

  return { isAdmin, loading, login, logout };
}